module.exports = __webpack_public_path__ + "static/media/JPS Cover.81dc19ac.png";